import getUrlBase from "datastore/getUrlBase";
import paramsToQs from "util/paramsToQs";

export default async function get(url, params) {
  let fullUrl = `${getUrlBase()}${url}`;
  if (params && Object.keys(params).length > 0) {
    const urlParams = paramsToQs(params);
    fullUrl = `${getUrlBase()}${url}?${urlParams}`;
  }

  let response;
  try {
    response = await fetch(fullUrl, {
      method: "GET",
      mode: "cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      "Referrer-Policy": "unsafe-url",
    });
  } catch (error) {}

  return response;
}
